var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3906 4.57797C27.2552 4.52598 27.125 4.49987 26.9999 4.49987C26.7186 4.49987 26.4845 4.59904 26.2968 4.79682L19.9999 11.0782V8.50011C19.9999 7.26037 19.5598 6.20063 18.6795 5.32034C17.7992 4.44016 16.7396 4.00005 15.4998 4.00005H4.49991C3.26044 4.00005 2.20048 4.44016 1.32014 5.32034C0.440118 6.20063 0 7.26037 0 8.50011V19.5001C0 20.7397 0.440118 21.7994 1.32019 22.6796C2.20054 23.5599 3.2605 24 4.49997 24H15.4999C16.7397 24 17.7993 23.5599 18.6796 22.6796C19.5599 21.7994 20 20.7398 20 19.5001V16.9062L26.2969 23.2032C26.4846 23.4009 26.7187 23.5 27 23.5C27.1251 23.5 27.2553 23.474 27.3907 23.4221C27.7972 23.2449 28.0002 22.9377 28.0002 22.5002V5.50007C28 5.06236 27.797 4.75512 27.3906 4.57797Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9c7e8a90867bafa944e221e704a51e71.svg";
export { ForwardRef as ReactComponent };